"use client";
import {
  useDialogStore
} from "../__chunks/Y2U4BRIM.js";
import "../__chunks/T22PY7TE.js";
import {
  DialogContextProvider
} from "../__chunks/T2AZQXQU.js";
import "../__chunks/ABN76PSX.js";
import "../__chunks/RTNCFSKZ.js";
import "../__chunks/VOQWLFSQ.js";
import "../__chunks/5GGHRIN3.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/dialog/dialog-provider.tsx
import { jsx } from "react/jsx-runtime";
function DialogProvider(props = {}) {
  const store = useDialogStore(props);
  return /* @__PURE__ */ jsx(DialogContextProvider, { value: store, children: props.children });
}
export {
  DialogProvider
};
